import clsx from "clsx";
import React from "react";

export const PurchaseSubscriptionAcknowledgement = ({ setIsPurchaseSubscriptionAcknowledged, className }) => {
  return (
    <div className={clsx("form-check", className)}>
      <input
        type="checkbox"
        defaultChecked={false}
        id="purchaseSubscriptionAcknowledgement"
        style={ { float: "none" } }
        className="form-check-input me-2"
        onClick={ event => { setIsPurchaseSubscriptionAcknowledged(event.target.checked) } }
      />
      <label className="form-check-label plan-main-txt fw-bolder" htmlFor="purchaseSubscriptionAcknowledgement">
        I acknowledge I will need to purchase a subscription license for my practice or have my individual clients purchase a subscription license for this scale or bundle.
      </label>
    </div>
  )
}
